import React from 'react';

const SpecItem = ({ icon, label, value }) => (
  <div className="flex items-center gap-2">
    <div className="text-gray-900 w-5 h-5 flex items-center justify-center">
      {React.cloneElement(icon, { 
        size: 14, 
        className: 'w-3.5 h-3.5 sm:w-4 sm:h-4' 
      })}
    </div>
    <div>
      <div className="text-xs text-gray-500 font-medium">{label}</div>
      <div className="text-sm font-semibold text-gray-900">{value}</div>
    </div>
  </div>
);

export default SpecItem;